var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDesignShop = function SvgDesignShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.269 12.037c.373 0 .676.294.676.655 0 .334-.258.61-.591.65l-.085.006H6.301a.666.666 0 0 1-.676-.655c0-.334.258-.61.591-.65l.085-.006H20.27zM6.304 4.117a.665.665 0 0 1 .663.577l.006.084.048 5.335a.665.665 0 0 1-.657.673.665.665 0 0 1-.664-.577l-.006-.084-.048-5.335a.665.665 0 0 1 .658-.673zm2.709.889c.338 0 .617.254.658.583l.005.084v4.446a.665.665 0 0 1-.663.667.665.665 0 0 1-.659-.583l-.005-.084V5.673c0-.368.297-.667.664-.667zm2.655 1.778c.338 0 .617.255.658.584l.005.083v2.668a.665.665 0 0 1-.663.667.665.665 0 0 1-.659-.583l-.005-.084V7.451c0-.368.297-.667.664-.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.843 1c1.147 0 2.085.923 2.153 2.088l.004.135v4.963a.597.597 0 0 1-.588.607.595.595 0 0 1-.583-.524l-.005-.083V3.223a1 1 0 0 0-.88-1.005l-.1-.005H4.156a.992.992 0 0 0-.975.907l-.006.103v13.042a1 1 0 0 0 .88 1.006l.1.005h11.687a.992.992 0 0 0 .975-.907l.006-.104v-1.159c0-.335.263-.606.588-.606.298 0 .544.228.583.524l.005.082v1.16c0 1.182-.895 2.148-2.025 2.218l-.132.004H11.53v1.32h3.794c.34 0 .62.228.66.522l.005.074c0 .304-.253.555-.582.591l-.083.005H4.677c-.367 0-.665-.267-.665-.596 0-.303.253-.554.582-.59l.083-.005H8.47v-1.32H4.157c-1.147 0-2.085-.924-2.153-2.088L2 16.265V3.223c0-1.182.895-2.149 2.025-2.219L4.157 1h11.686z"
  })))));
};

export default SvgDesignShop;